module.exports = "An error occured.\n\nPlease try again later."


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/en/errorWhileFetchingCampaigns.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/en/errorWhileFetchingCampaigns.md
// module chunks = 18